import '../css/Button.css';

const isHexColor = (c) => typeof c === "string" && c.startsWith("#");

const Button = ({color= "blue", img= "username.png", msg= "Sign in  with Email", url={}, onClick, variant, secondary = false}) => {
    const onButtonClick = () => {
        if(onClick){
            onClick(msg);
        }
    }

    const isFlat = variant === "flat";
    const useInline = isHexColor(color);
    const buttonClass = isFlat ? `custom-button flat${secondary ? " secondary" : ""}` : useInline ? "custom-button" : `custom-button ${color}`;
    const buttonStyle = isFlat
        ? { backgroundColor: "#FFFFFF", borderColor: "#D1D5DB", color: "#000000" }
        : useInline ? { backgroundColor: color, borderColor: color } : {};

    return(
        <div className={isFlat ? "button-container flat-button-container" : "button-container"}>
            <a href={url}>
            <button  className={buttonClass} style={buttonStyle} onClick={onButtonClick} >
                <img src={`${img}`} alt={`${msg}`} />
                <p>{msg}</p>
            </button>
            </a>
            {/* <button disabled={disabled} className={`custom-button ${color}  ${size} ${type}`} onClick={onButtonClick}>{name}</button> */}
        </div>
    )
}
export default Button;